module.exports = __webpack_public_path__ + "static/img/3.5838c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncq/3.png
// module id = F+/9
// module chunks = 1